// hooks/useUser.js
import { useEffect, useState } from 'react';

export const useUser = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    fetch('http://196.216.9.34:5020/api/users/me', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        if (data.message) setError(data.message);
        else setUser(data);
      })
      .catch(() => setError('Error fetching user'));
  }, []);

  return { user, error };
};
